import React from 'react';
import { Commission } from '../types/commission';
import { DollarSign, Users, FileText, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
interface SummaryMetricsProps {
  data: Commission[];
}
export function SummaryMetrics({
  data
}: SummaryMetricsProps) {
  const totalVolume = data.reduce((acc, curr) => acc + curr.total, 0);
  const totalUnits = data.reduce((acc, curr) => acc + curr.units, 0);
  const activeUsers = data.length;
  const avgCommission = activeUsers > 0 ? totalVolume / activeUsers : 0;
  const metrics = [{
    label: 'Total Commission',
    value: `$${totalVolume.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`,
    icon: DollarSign,
    color: 'text-emerald-600',
    bg: 'bg-emerald-50'
  }, {
    label: 'Total Units',
    value: totalUnits,
    icon: FileText,
    color: 'text-blue-600',
    bg: 'bg-blue-50'
  }, {
    label: 'Active Users',
    value: activeUsers,
    icon: Users,
    color: 'text-violet-600',
    bg: 'bg-violet-50'
  }, {
    label: 'Avg. Commission',
    value: `$${avgCommission.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })}`,
    icon: TrendingUp,
    color: 'text-amber-600',
    bg: 'bg-amber-50'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-135">
      {metrics.map((metric, index) => <motion.div key={metric.label} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: index * 0.1
    }} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4" data-id="element-136">
          <div className={`p-3 rounded-lg ${metric.bg} ${metric.color}`} data-id="element-137">
            <metric.icon size={20} data-id="element-138" />
          </div>
          <div data-id="element-139">
            <p className="text-sm text-slate-500 font-medium" data-id="element-140">{metric.label}</p>
            <p className="text-xl font-bold text-slate-900" data-id="element-141">{metric.value}</p>
          </div>
        </motion.div>)}
    </div>;
}